import React from 'react'

const PlansComponent = () => {
  return (
      <div>
           <div>
          <div class="mb-5 pb-5">

              </div>
              </div>
          
      <div class="mb-5 pb-5">


<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/MaterialDesign-Webfont/5.3.45/css/materialdesignicons.css" integrity="sha256-NAxhqDvtY0l4xn+YVa6WjAcmd94NNfttjNsDmNatFVc=" crossorigin="anonymous"></link>

<section class="section" id="pricing">
<div class="container">

    <div class="row">
        <div class="col-lg-12 animate-fade">
            <div class="title-box text-center">
            <h1 class="display-4 fw-normal text-white"><b>Pricing Plans</b></h1>
   
            </div>
        </div>
    </div>


    <div class="row mt-1 ">
        <div class="col-lg-4 p-2 animate-fade ">
            <div class="pricing-box bugbountycontent  text-light  bg-white  p-3 rounded mt-4">
                <i class="mdi mdi-account h1"></i>
                <h4 class="f-20">Starter</h4>

                <div class="mt-4 pt-2">
                    <p class="mb-2 f-18">Features</p>

                    <p class="mb-2"><i class="mdi mdi-checkbox-marked-circle text-success f-18 mr-2"></i><b>1 Year</b>
                        Limited Access</p>
                    <p class="mb-2"><i class="mdi mdi-checkbox-marked-circle text-success f-18 mr-2"></i><b>1</b>
                       Access to Bug bounty lab</p>
                    <p class="mb-2"><i class="mdi mdi-close-circle text-danger f-18 mr-2"></i><b>Top 50</b>
                        Hacking tools</p>
                        <p class="mb-2"><i class="mdi mdi-close-circle text-danger f-18 mr-2"></i><b>Top 50</b>
                        Hacking tools</p>
                    <p class="mb-2"><i class="mdi mdi-close-circle text-danger f-18 mr-2"></i><b>Public</b>
                        Displays
                    </p>
                </div>


                
                <div class="pricing-plan mt-4 pt-2">
                    <h4 class=""><s> $9.99</s> <span class="plan pl-3 text-light">$8.99 </span></h4>
                    <p class=" mb-0">Per Month</p>
                </div>


                <div class="mt-4 pt-3">
                    <a href="" class="btn btn-primary btn-rounded">Purchase Now</a>
                </div>
            </div>
        </div>

        <div class="col-lg-4 p-2 animate-fade ">
            <div class="pricing-box bugbountycontent shadow  text-light  bg-white bugbountycontent  p-3 rounded mt-4">
                <div class="pricing-badge">
                    <span class="badge">Featured</span>
                </div>

                <i class="mdi mdi-account-multiple h1 text-primary"></i>
                <h4 class="f-20 text-primary">Personal</h4>


                <div class="mt-4 pt-2">
                    <p class="mb-2 f-18">Features</p>

                    <p class="mb-2"><i class="mdi mdi-checkbox-marked-circle text-success f-18 mr-2"></i><b>Unlimited</b>
                        Target Audience</p>
                    <p class="mb-2"><i class="mdi mdi-checkbox-marked-circle text-success f-18 mr-2"></i><b>1</b>
                        User Account</p>
                    <p class="mb-2"><i class="mdi mdi-checkbox-marked-circle text-success f-18 mr-2"></i><b>100+</b>
                        Video Tuts</p>
                    <p class="mb-2"><i class="mdi mdi-close-circle text-danger f-18 mr-2"></i><b>Public</b>
                        Displays
                    </p>
                </div>



                <div class="pricing-plan mt-4 pt-2">
                    <h4 class=""><s> $19.99</s> <span class="plan pl-3 text-dark">$18.99 </span></h4>
                    <p class=" mb-0">Per Month</p>
                </div>

                <div class="mt-4 pt-3">
                    <a href="" class="btn btn-primary btn-rounded">Purchase Now</a>
                </div>
            </div>
        </div>

        <div class="col-lg-4 p-2 animate-fade ">
            <div class="pricing-box bugbountycontent  text-light  bg-white  p-3 rounded mt-4">
                <i class="mdi mdi-account-multiple-plus h1"></i>
                <h4 class="f-20">Ultimate</h4>


                <div class="mt-4 pt-2">
                    <p class="mb-2 f-18">Features</p>

                    <p class="mb-2"><i class="mdi mdi-checkbox-marked-circle text-success f-18 mr-2"></i><b>Unlimited</b>
                        Target Audience</p>
                    <p class="mb-2"><i class="mdi mdi-checkbox-marked-circle text-success f-18 mr-2"></i><b>1</b>
                        User Account</p>
                    <p class="mb-2"><i class="mdi mdi-checkbox-marked-circle text-success f-18 mr-2"></i><b>100+</b>
                        Video Tuts</p>
                    <p class="mb-2"><i class="mdi mdi-checkbox-marked-circle text-success f-18 mr-2"></i><b>Public</b>
                        Displays
                    </p>
                </div>


                

                <div class="pricing-plan mt-4 pt-2">
                    <h4 class=""><s> $29.99</s> <span class="plan pl-3 text-dark">$28.99 </span></h4>
                    <p class=" mb-0">Per Month</p>
                </div>

                <div class="mt-4 pt-3">
                    <a href="" class="btn btn-primary btn-rounded">Purchase Now</a>
                </div>
            </div>
        </div>
    </div>
</div>
</section></div>
    </div>
  )
}

export default PlansComponent
